import { Location } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { StaticService } from 'src/app/services/static.service';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { InfoCardComponent } from '../info-card/info-card.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  previousRoute = '';
  redirectMsg = '';
  errorLogin: boolean = false;
  fromSeats: boolean = false;
  loadingLogin: boolean = false;
  // Alta dentro del propio diálogo, solo cuando el login se abre en mitad de
  // una compra: salir a /signup cerraba el mapa y se perdía lo elegido.
  registering: boolean = false;
  registerMsg: string = '';

  constructor(
    private staticService: StaticService,
    private router: Router,
    private location: Location,
    private auth: AuthenticationService,
    private dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit(): void {
    if (this.data && this.data.seats) {
      this.fromSeats = true;
    }
    this.previousRoute = this.staticService.getFrom();
    switch (this.previousRoute) {
      case 'subir':
        this.redirectMsg =
          '¡Inicia sesión o regístrate para poder subir tu propio lok!';
        break;
      case 'favoritos':
        this.redirectMsg =
          '¡Inicia sesión o regístrate para tener acceso a tus loks favoritos!';
        break;
      case 'cuenta':
        this.redirectMsg =
          '¡Inicia sesión o regístrate para poder acceder a tu cuenta!';
        break;
      default:
        break;
    }
    this.staticService.removeFrom();
  }

  getRedirect(event: any) {
    this.redirectMsg = event;
  }

  getErrorLogin(event: any) {
    this.errorLogin = event;
    this.loadingLogin = false;
  }

  goRegister(event: any) {
    if (!event) {
      return;
    }
    if (this.fromSeats) {
      this.registerMsg = '';
      this.registering = true;
      return;
    }
    this.router.navigate(['/signup']);
  }

  /**
   * Alta hecha desde el diálogo. La cuenta no sirve hasta verificar el correo,
   * así que se vuelve a la vista de login con el diálogo abierto: lo que
   * hubiera debajo (mapa, asistente) sigue como estaba para cuando vuelva.
   */
  registered(ok: boolean) {
    if (!ok) {
      return;
    }
    this.registering = false;
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: 'Te has registrado correctamente. Verifica tu correo electrónico y vuelve a esta pantalla para iniciar sesión y continuar.',
        btnCancel: false
      }
    });
  }

  validate() {
    this.loadingLogin = false;
  }

  loadingForm(loading: boolean) {
    if (!this.fromSeats) {
      this.loadingLogin = loading;
    }
  }

}
